import { Component, OnInit, ViewChild, ChangeDetectorRef, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { GlobalService } from './../services/global.service';
import { HttpService } from './../services/http.service';
import { Router, ActivatedRoute } from '@angular/router';
import { PiHistoryService } from './../services/pihistory-service';
import { map } from 'rxjs/operators';
import { UntypedFormControl } from '@angular/forms';
import { RunPIHistoryDataComponent } from './run-pihistory-data/run-pihistory-data.component';
import { FilterModel } from '../models/filter/filter-request.model';
import { FilterFieldTypes } from '../shared/common-constants';
import { FilterResponseModel } from '../models/filter/filter-response.model';
import { NgbPopover } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-pihistory-data',
  templateUrl: './pihistory-data.component.html',
  styleUrls: ['./pihistory-data.component.css']
})
export class pihistoryDataComponent implements OnInit {

  [x: string]: any;
  runList: MatTableDataSource<any>;
  @ViewChild('runsTableSort', { static: true }) public runsTableSort: MatSort;
  @ViewChild('runsPaginator', { static: true }) runsPaginator: MatPaginator;
  firstTableClass: string = "hideData";
  noData;
  isLoader: boolean = false;
  nameFilter = new UntypedFormControl('');
  statusFilter = new UntypedFormControl('');
  displayedColumns = ['runBy', 'runTime', 'lastCheckedStaus', 'parameters', 'Action'];
  filterValues = {
    runBy: '',
    status: ''
  };
  filterList: FilterModel[] = [];
  selectedFilters: FilterResponseModel[] = [];
  masterData;
  @ViewChild('popOver') public popover: NgbPopover;


  constructor(
    public globalService: GlobalService,
    private readonly httpService: HttpService,
    private readonly piHistoryService: PiHistoryService,
    private readonly router: Router,
    private readonly _router: ActivatedRoute,
    public dialog: MatDialog
  ) { }

  ngOnInit() {
    this.refreshAllRuns();
    this.nameFilter.valueChanges
      .subscribe(
        runBy => {
          this.filterValues.runBy = runBy;
          this.runList.filter = JSON.stringify(this.filterValues);
        }
      )

    this.statusFilter.valueChanges
      .subscribe(
        status => {
          this.filterValues.status = status;
          this.runList.filter = JSON.stringify(this.filterValues);
        }
      )
  }

  getAllHistoryRuns() {
    this.isLoader = true;
    this.piHistoryService.getAllRuns().subscribe((response: any): void => {
      if (response.length > 0) {
        this.isLoader = false;
        this.masterData = [...response];
        this.runList = new MatTableDataSource(response);
        this.noData = this.runList.connect().pipe(map(data => data.length === 0));
        this.runList.sort = this.runsTableSort;
        this.runList.paginator = this.runsPaginator;
        this.firstTableClass = "showData";
        if (this.filterList.length == 0) {
          this.createFilterList();
        }
      } else {
        this.isLoader = false;
      }
    });
  }
  checkRun(row) {
    this.piHistoryService.getUpdatedRun(row.runId).subscribe((response: any): void => {
      row.status = response.value.status;
    });
  }

  refreshAllRuns() {
    this.piHistoryService.refreshAll().subscribe((response: any): void => {
      this.getAllHistoryRuns();
    });
  }

  deserialize(json): any[] {
    let collection: any[] = [];
    collection.push(JSON.parse(json));
    return collection;
  }

  viewParameterDilog(parameter): void {
    this.dialog.open(ParameterModalComponent, {
      width: '80%',
      panelClass: 'confirm-modalbox-dark',
      height: 'auto',
      data: this.deserialize(parameter)
    });
  }

  runParameterDialog(): void {
    const dialogRef = this.dialog.open(RunPIHistoryDataComponent, {
      width: '80%',
      panelClass: 'confirm-modalbox-dark',
      height: 'auto'
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result == "Success") {
        this.refreshAllRuns();
      }
    });
  }
  
  /**Creates data for filter list */
  createFilterList() {
    let columns: string[] = ["runBy", "runAt", "status"];
    for (let a = 0; a < columns.length; a++) {
      let tempFilter: FilterModel = new FilterModel();
      tempFilter.fieldName = this.globalService.replaceDisplayText(columns[a]);
      tempFilter.fieldType = FilterFieldTypes.text;
      let unique;
      if (columns[a] == "runBy") {
        unique = [...new Set(this.runList.data.map(a => a.runBy))];
      } else if (columns[a] == "runAt") {
        unique = [...new Set(this.runList.data.map(a => a.runAt))];
      } else if (columns[a] == "status") {
        unique = [...new Set(this.runList.data.map(a => a.status))];
      } 
      tempFilter.values = unique;
      this.filterList.push(tempFilter);
    }
  }

  /**
   * Returns data from child filter component
   * @param event
   */
  filterResponse(event) {
    let filterResponse: FilterResponseModel = event.filterResponse;
    this.runList.data = this.globalService.conditionalDataFiltering(filterResponse, this.runList.data);
    this.selectedFilters.push(filterResponse);
    if (this.popover.isOpen()) this.popover.close();
  }

  /**
   * Removes that filter
   * @param selectedFilter
   */
  remove(selectedFilter: FilterResponseModel): void {
    const index = this.selectedFilters.indexOf(selectedFilter);
    if (index >= 0) {
      this.selectedFilters.splice(index, 1);
      this.runList.data = this.masterData.slice(0);
      if (this.selectedFilters.length > 0) {
        for (let element of this.selectedFilters) {
          this.runList.data = this.globalService.conditionalDataFiltering(element, this.runList.data);
        }
      }
    }
  }

}

@Component({
  selector: 'parameter-modal-component',
  templateUrl: './parameter-modal.component.html',
  styleUrls: ['./parameter-modal.component.css']
})

export class ParameterModalComponent {

  editDisabled: boolean = true;
  Heading: string = "Parameters";


  constructor(
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<ParameterModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data,
    public httpService: HttpService,
    public globals: GlobalService,
    public router: Router,
    public _router: ActivatedRoute
  ) { };


  onCancelClick(): void {
    this.dialogRef.close("Cancel");
  }

}
